import { graphql } from 'gql';

export const bimWorkOrderPriceRevisionCodeFilterGql = graphql(`
    query bimWorkOrderPriceRevisionCodeFilter(
        $revisionType: WorkOrderPriceRevisionTypeEnum
        $workOrderPriceId: Long!
        $where: FilterValueOfStringFilterInput
        $order: [FilterValueOfStringSortInput!]
        $take: Int
        $skip: Int
    ) {
        bimWorkOrderPriceRevisionCodeFilter(
            revisionType: $revisionType
            workOrderPriceId: $workOrderPriceId
            where: $where
            order: $order
            take: $take
            skip: $skip
        ) {
            items {
                value
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const bimWorkOrderPriceRevisionNameFilterGql = graphql(`
    query bimWorkOrderPriceRevisionNameFilter(
        $revisionType: WorkOrderPriceRevisionTypeEnum
        $workOrderPriceId: Long!
        $where: FilterValueOfStringFilterInput
        $order: [FilterValueOfStringSortInput!]
        $take: Int
        $skip: Int
    ) {
        bimWorkOrderPriceRevisionNameFilter(
            revisionType: $revisionType
            workOrderPriceId: $workOrderPriceId
            where: $where
            order: $order
            take: $take
            skip: $skip
        ) {
            items {
                value
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);
